import React from 'react';
import { Routes, Route } from 'react-router-dom';
import './App.css';

import ScrollToTop from './components/ScrollToTop';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import CookieConsent from './components/CookieConsent';
// --- 1. IMPORT THE NEW CTA SECTION ---
import CTASection from './components/CTASection';

// Pages
import Home from './pages/Home';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfService from './pages/TermsOfService';
import Contact from './pages/Contact';
// --- 2. ENSURE SERVICES IS IMPORTED ---
import Services from './pages/Services';
import Solutions from './pages/Solutions';
import AboutUs from './pages/AboutUs';

function App() {
  return (
    <div className="App">
      <ScrollToTop />
      <Navbar />
      <Routes>
        <Route path="/" element={<Home />} />
        {/* --- 3. ENSURE THE ROUTE EXISTS --- */}
        <Route path="/services" element={<Services />} />
        <Route path="/solutions" element={<Solutions />} />
        <Route path="/about" element={<AboutUs />} />

        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsOfService />} />
      </Routes>
      
      {/* --- 4. ADD CTA SECTION BEFORE FOOTER --- */}
      <CTASection />
      
      <Footer />
      <CookieConsent />
    </div>
  );
}

export default App;